import type { Component } from 'vue';

import type { UnifiedLearningAssetTypeValue } from '~/types/unifiedLearningAsset';

import { LearningAssetType } from '~/graphql/generated/graphql';

const learningAssetContentRegistry: Partial<Record<UnifiedLearningAssetTypeValue, Component>> = {
  [LearningAssetType.StoryAsset]: defineAsyncComponent(() => import('~/components/Unified/Activities/Content/StoryContent.vue')),
};

export const getLearningAssetContentComponent = (type: UnifiedLearningAssetTypeValue): Component | undefined =>
  learningAssetContentRegistry[type];
